import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { axiosGetData } from "@shared/api/clients";
import { User } from "./Me.types";
import { AxiosError } from "axios";

export const getMe = async (): Promise<User> => {
  const response = await axiosGetData<User>("v1/user/me");
  return response;
};

export const useMeQuery = (
  options?: Partial<UseQueryOptions<User, AxiosError>>,
) => {
  return useQuery<User, AxiosError>({
    queryKey: ["me"],
    queryFn: getMe,
    retry: false,
    throwOnError: false,
    ...options,
  });
};
